import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Axios from "axios";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./AddIssuedBook.css";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddIssuedBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        issuedDate: "",
        dueDate: "",
        returnDate: "",
        studentId: "",
      },
      error: {
        issuedError: "",
        dueError: "",
        studentError: "",
        returnError: "",
      },
      studentList: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getStudents();
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  getStudents = async () => {
    try {
      const response = await Axios.get(`${url}/api/students`, {
        headers: { Authorization: `Bearer ${this.props.adminToken}` },
      });
      if (response.data.students.length !== 0) {
        this.setState({
          studentList: response.data.students,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudents();
      }
    }
  };

  setData = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        issuedDate: data.issuedDate,
        dueDate: data.dueDate,
        returnDate: data.returnDate ? data.returnDate : "",
        studentId: data.studentId._id,
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = () => {
    let issuedError = "";
    let dueError = "";
    let studentError = "";
    let returnError = "";

    if (this.state.data.issuedDate === "") {
      issuedError = "Please enter issued date";
    }

    if (this.state.data.dueDate === "") {
      dueError = "Please enter due date";
    }

    if (this.state.data.studentId === "") {
      studentError = "Student must be entered";
    }

    if (this.props.editStatus) {
      if (this.state.data.returnDate === "") {
        returnError = "Please enter the return date";
      }
    }

    if (issuedError || dueError || studentError || returnError) {
      this.setState({
        error: {
          issuedError,
          dueError,
          studentError,
          returnError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          issuedError: "",
          dueError: "",
          studentError: "",
          returnError: "",
        },
      });
      return false;
    }
  };

  filterData = (data) => {
    let changedData = data;
    if (changedData.returnDate === "") {
      delete changedData.returnDate;
    }
    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let data = this.filterData(this.state.data);
        if (this.props.editStatus) {
          const response = await Axios.put(
            `${url}/api/book-issued/${this.props.bookId}/issue/${this.props.issuedId}`,
            this.state.data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (
            response.data.message === "Book issued data edited successfully"
          ) {
            this.setState({
              data: {
                issuedDate: "",
                dueDate: "",
                returnDate: "",
                studentId: "",
              },
            });
            this.props.handleCancelEdit();
            this.props.getBookDetails(this.props.bookId);
          }
        } else {
          const response = await Axios.post(
            `${url}/api/book-issued/${this.props.bookId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (response.data.message === "Book issued successfully") {
            this.setState({
              data: {
                issuedDate: "",
                dueDate: "",
                returnDate: "",
                studentId: "",
              },
              loading: false,
            });
            this.props.getBookDetails(this.props.bookId);
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="issuedDate"
            type="date"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.error.issuedError ? true : false}
            helperText={this.state.error.issuedError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.issuedDate}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          <TextField
            name="dueDate"
            type="date"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.error.dueError ? true : false}
            helperText={this.state.error.dueError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: {
                min: 0,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.dueDate}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.props.editStatus ? (
            <TextField
              name="returnDate"
              type="date"
              required
              fullWidth
              variant="outlined"
              margin="normal"
              error={this.state.error.returnError ? true : false}
              helperText={this.state.error.returnError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.returnDate}
              onChange={this.handleChange}
            />
          ) : (
            "N/A"
          )}
        </TableCell>
        <TableCell align="center">
          <TextField
            name="studentId"
            select
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.error.studentError ? true : false}
            helperText={this.state.error.studentError}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.studentId}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            {this.state.studentList.map((data, index) => (
              <option key={index} value={data._id}>
                {data.firstName} {data.middleName} {data.lastName} (
                {data.studentClass} - {data.section})
              </option>
            ))}
          </TextField>
        </TableCell>

        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update"
                className={classes.tooltip}
                onClick={this.handleSubmit}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Cancel"
                className={classes.tooltip}
                onClick={this.props.handleCancelEdit}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              arrow
              title="Add"
              className={classes.tooltip}
              onClick={this.handleSubmit}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddIssuedBook)));
